<template>
  <div
    id="tweenImg"
    :class="`top-info-compo ${isShrink ? 'shrink' : ''}`"
  >
    <div class="info-view flx-row-arn">
      <van-image
        class="logo"
        round
        :src="require('@/imgs/logo.png')"
        :show-error="false"
        :show-loading="false"
        @click="isShrink = !isShrink"
      />
      <p>
        信义金御半山·珑门
      </p>
      <span class="split" />
      <div
        class="flx-col-btw"
        @click="phoneCall"
      >
        <van-image
          style="margin-right: 4px"
          :src="require('@/imgs/icon/phone.png')"
          :width="21"
          :show-error="false"
          :show-loading="false"
        />
        <p style="font-size: 12px">
          电话
        </p>
      </div>
      <van-image
        style="margin-right: 4px"
        :src="require('@/imgs/more.png')"
        :width="18"
        :height="18"
        :show-error="false"
        :show-loading="false"
        @click="isShrink = true"
      />
    </div>
  </div>
</template>

<script>
import Hammer from 'hammerjs';

export default {
  components: {},
  data() {
    return {
      isShrink: false,
      // 一下均是缩放的js需要
      config: {},
      timer: false,
      translateX: 0,
      translateY: 0,
      scale: 1,
      firstTouch: false,
      relateX: 0,
      relateY: 0,
      oldX: 0,
      oldY: 0,
      oldScale: 1,
    };
  },
  mounted() {
    // 加载双指缩放事件
    this.$nextTick(() => {
      this.picInit();
    });
    // 根据路由确定是否自动收缩
    setTimeout(() => {
      this.isShrink = true;
    }, 500);
    // setInterval(() => {
    //   const { name } = this.$route;
    //   if (name === this.name) return;
    //   this.name = name;
    //   // if (['project', 'park_p', 'house'].includes(name)) {
    //   //   this.isShrink = true;
    //   // } else {
    //   //   this.isShrink = false;
    //   // }
    // }, 200);
  },
  methods: {
    // 初始化hammer
    picInit() {
      this.id = document.getElementById('tweenImg');
      this.mc = new Hammer(this.id);
      this.relateX = (document.body.clientWidth - this.id.offsetWidth) / 2;
      this.relateY = (document.body.clientHeight - this.id.offsetHeight) / 2;

      this.mc.add(new Hammer.Pan({
        direction: Hammer.DIRECTION_ALL,
        threshold: 0,
        pointers: 0,
      }));
      this.mc.add(new Hammer.Pinch({
        threshold: 0,
      })).recognizeWith(this.mc.get('pan'));

      this.mc.on('hammer.input', this.isFinal);
      this.mc.on('panstart panmove', this.onPan);
      this.mc.on('pinchstart pinchmove', this.onPinch);

      this.setPosition();
    },
    // 打电话
    phoneCall() {
      const phone = '28889888';
      const phoneUrl = `tel:${phone}`;
      window.location.href = phoneUrl;
    },
    // 单点触发 - 利落
    onPan(ev) {
      if (this.firstTouch) {
        this.oldX = this.relateX;
        this.oldY = this.relateY;
      }
      this.translateX = this.oldX + ev.deltaX;
      this.translateY = this.oldY + ev.deltaY;
      const position = {
        translateX: this.translateX,
        translateY: this.translateY,
        // scale: this.scale,
      };
      this.selfPosition(position);
      this.firstTouch = false;
    },
    // 多点触发 - 缩放
    onPinch(ev) {
      this.scale = this.oldScale * ev.scale;
      this.selfPosition({
        translateX: this.translateX,
        translateY: this.translateY,
        // scale: this.scale,
      });
      this.selfPosition(this.position);
    },
    isFinal(ev) {
      if (ev.isFinal) {
        // this.oldX = this.translateX;
        // this.oldY = this.translateY;
        this.oldX = 0;
        this.oldY = Math.max(this.translateY, -5);
        // 靠边
        this.selfPosition({
          translateX: 0,
          translateY: Math.max(this.translateY, -5),
        });
      }
    },
    tempPos(pos) {
      // const scale = pos.scale > 2.0 ? 2.0 : pos.scale;
      let style = [
        `translate3d(${pos.translateX}px, ${pos.translateY}px, 0)`,
        // `scale(${scale}, ${scale})`,
      ];
      style = style.join(' ');
      this.id.style.transform = style;
    },
    picAnimate() {
      return window[Hammer.prefixed(window, 'requestAnimationFrame')] || function (callback) {
        setTimeout(callback, 1000 / 60);
      };
    },
    // 初始化图片地位及缩放
    setPosition() {
      this.selfPosition({
        // translateX: this.relateX,
        // translateY: this.relateY,
        // scale: this.scale,
      });
    },
    selfPosition(pos) {
      return this.picAnimate()(() => this.tempPos(pos));
    },

  },
};
</script>
<style lang="less" scoped>
@shrinkWidth: 58px;
@width: 7rem;
.top-info-compo {
  position: absolute;
  left: .2rem;
  top: 2vh;
  z-index: 3001;
  width: @width;
  height: @shrinkWidth;
  overflow: hidden;
  font-size: 15px;
  color: white;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: @shrinkWidth / 2;
  transition: width .5s linear;
  overflow: hidden;
  .info-view {
    width: @width;
    height: @shrinkWidth;
  }
  & .item {
    flex-shrink: 0;
  }
  &.shrink {
    width: @shrinkWidth;
    justify-content: center;
  }
  .split {
    width: 1px;
    height: 54%;
    background-color: #fff;
    transform: scaleX(0.5);
  }
  .logo {
    width: @shrinkWidth * .8;
    height: @shrinkWidth * .8;
  }

}
</style>
